import { Injectable, forwardRef, Inject }       from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }           from '../api/api.service';
import { CompanySettingsModel } from '../companies/models/company.settings';
import { ConfirmService }       from '../messages/confirm/confirm.service';
import { SessionService }       from '../sessions/session.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerPortalService {
  constructor (
    @Inject(forwardRef(() => ApiService)) private apiService      : ApiService,
    @Inject(forwardRef(() => ConfirmService)) private confirmService  : ConfirmService,
    @Inject(forwardRef(() => SessionService))
    private sessionService  : SessionService,
    private translateService: TranslateService
  ) {}

  activate () : Promise<any> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', {
        name: this.translateService.instant('CUSTOMER_SPACE.CUSTOMER_PORTAL.TITLE')
      }))
      .then(() => this.apiService.patch('/company_settings', {
          has_customer_portal: true
        }, 'company_setting'))
      .then(() => this.sessionService.refresh());
  }

  deactivate () : Promise<any> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.INTEGRATIONS.DEACTIVATE', {
        name: this.translateService.instant('CUSTOMER_SPACE.CUSTOMER_PORTAL.TITLE')
      }))
      .then(() => this.apiService.patch('/company_settings', {
          has_customer_portal: false
        }, 'company_setting'))
      .then(() => this.sessionService.refresh());
  }

  getSettings () : Promise<CompanySettingsModel> {
    return this.apiService.get('/company_settings');
  }
}
